<template>
  <div id="bind-email-layer">
    <e-header :stitle="stitle"></e-header>
    <img src="../../assets/images/bind-email/bind-email-img.png" class="bind-email-img" alt="">
    <div class="bind-email-content">
      <h3 class="bing-email-title">绑定邮箱</h3>
      <el-form @submit.native.prevent :model="emailForm" :rules="emailRules" ref="emailForm" class="email-Form">
        <el-form-item prop="email">
          <el-input placeholder="请输入您的邮箱地址" v-model="emailForm.email"></el-input>
        </el-form-item>
        <el-form-item prop="emailcode">
          <el-input placeholder="请输入邮箱验证码" v-model="emailForm.emailcode"></el-input>
          <div class="code-btn">
            <el-button type="primary" :disabled="!sendAuthCode" @click="getEmailCode" v-show="sendAuthCode">获取验证码</el-button>
            <el-button type="primary" v-show="!sendAuthCode"> {{auth_time}}秒</el-button>
          </div>
        </el-form-item>
        <el-form-item style="margin-top: -10px; margin-bottom: 0; text-align:right; color:#666666;">
          没有收到邮箱验证码？
        </el-form-item>
        <el-button type="primary" class="bind-submit" @click="bindEmailHandle">确定</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import eHeader from '@/components/eHeader'
import { getEmailCodeApi } from '@/api/common'
import { bindEmailApi } from '@/api/bind-email'
export default {
  components: {
    eHeader
  },
  data () {
    return {
      stitle: '用户注册',
      emailForm: {
        email: '',
        emailcode: ''
      },
      emailRules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
        ],
        emailcode: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      sendAuthCode: true,
      auth_time: 60
    }
  },
  methods: {
    getEmailCode() {
      this.$refs.emailForm.validateField('email', error => {
        if (!error) {
          this.sendAuthCode = false;
          getEmailCodeApi(this.emailForm.email).then( res => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'warning'
              });
              this.sendAuthCode = true;
              this.auth_time = 60;
            } else {
              this.$message({
                message: '验证码发送成功',
                type: 'success'
              });

              // 倒计时
              this.auth_time = 60;
              var auth_timetimer = setInterval(() => {
                this.auth_time--;
                if (this.auth_time <= 0) {
                  this.sendAuthCode = true;
                  clearInterval(auth_timetimer);
                }
              }, 1000);
            }
          }).catch((err) => {
            console.log(err)
          });
        }
      }) 
    },
    bindEmailHandle() {
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          bindEmailApi({
            email: this.emailForm.email,
            code: this.emailForm.emailcode
          }).then(res => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'warning'
              });
            } else {
              this.$message({
                message: '绑定邮箱成功！',
                type: 'success'
              });

              setTimeout(() => {
                this.$router.push('/')
              }, 1000)
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          console.log('error submit!')
          return false
        }
      })
    }
  }
}
</script>
<style>
  #bind-email-layer .email-Form input{
    height: 48px;
  }
</style>
<style scoped>
  .bind-email-content{
    width: 401px;
    margin: 141px auto 0;
    background: #ffffff;
    position: relative;
    z-index: 2;
  }

  .email-Form{
    margin-top: 50px;
  }

  .bing-email-title{
    font-size: 24px;
    color: #333333;
    text-align: center;
  }

  .smgcode{
    position: relative;
  }

  .code-btn{
    position: absolute;
    right: 0;
    top: 0;
  }

  .code-btn button{
    height: 48px;
  }

  .bind-submit{
    width: 409px;
    height: 50px;
    margin-top: 50px;
  }

  .bind-email-img{
    display: block;
    width: 319px;
    position: fixed;
    /* left: 50%; */
    /* margin-left: -260px; */
    left: 20px;
    bottom: 108px;
  }
</style>